import React from "react";
import AiCreditManager from "../shared/AiCreditManager/AiCreditManager";

export default function AiCreditsPage() {
  return (
    <div style={{ width: "100%", backgroundColor: "white", minHeight: "100vh" }}>
        <div style={{ padding: "20px" }}>
          <AiCreditManager />
        </div>
    </div>
  );
}
